import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/20/solid";
import { Field, Form, FormikProps, withFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Error } from "../components/Error";
import { CartItem, PromoCodeType } from "../models/Cart";
import { cartActions } from "../store/cart";
import { State } from "../store/store";
import { calculateDiscount } from "../utils/cart";
import { store } from "..";
import { useDarkMode } from "usehooks-ts";
import { Button } from "@/components/ui/button";
import { XCircleIcon } from "@heroicons/react/24/outline";

interface PromoCodeFormValues {
  code: string;
}

const PromoCodeInnerForm = (props: FormikProps<PromoCodeFormValues>) => {
  const darkMode = useDarkMode();
  const {
    touched,
    errors,
    isSubmitting,
    handleSubmit,
    values,
    resetForm,
    setFieldValue,
  } = props;
  const dispatch = useDispatch();
  // const billingDetailsSubmitting = useSelector(
  //   (state: State) => state.cart.billingDetailsSubmitting
  // );
  const promoCodeError = useSelector(
    (state: State) => state.cart.promoCodeError
  );
  const appliedPromoCode = useSelector(
    (state: State) => state.cart.appliedPromoCode
  );

  useEffect(() => {
    setFieldValue("code", appliedPromoCode?.name);
  }, []);

  return (
    <Form>
      <div className="rounded-lg dark:bg-primary border dark:border-white/5 text-primary-foreground text-card-foreground shadow-sm mb-4 px-4 pb-4 pt-3">
        {/* <label
          htmlFor="promoCode"
          className="block text-sm font-medium text-gray-700 dark:text-white"
        >
          Promo Code
        </label> */}
        <div className="mt-1 flex space-x-4">
          <div className="w-full relative">
            <Field
              type="text"
              id="code"
              name="code"
              disabled={appliedPromoCode}
              className={`block w-full rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300 dark:ring-white/5 placeholder:text-gray-400 dark:text-gray-400 focus:ring-2 focus:ring-inset dark:focus:ring-indigo-600 focus:ring-primary sm:text-sm sm:leading-6 ${
                darkMode.isDarkMode
                  ? "bg-zinc-800 border-zinc-700 shadow-md text-white"
                  : "bg-white border-gray-300 shadow-sm text-black"
              }`}
              placeholder="Enter code"
            />
            {appliedPromoCode && (
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                <CheckCircleIcon
                  className="h-5 w-5 text-green-600"
                  aria-hidden="true"
                />
              </div>
            )}
          </div>
          {!appliedPromoCode ? (
            <Button
              onClick={() => {
                handleSubmit();
              }}
              size="sm"
              disabled={!values.code}
              variant={darkMode.isDarkMode ? "outline" : "default"}
              className="dark:text-primary"
            >
              Apply
            </Button>
          ) : (
            <Button
              onClick={() => {
                dispatch(cartActions.RemovePromoCode());
                resetForm({
                  values: {
                    code: "",
                  },
                });
              }}
              size="sm"
              disabled={!values.code}
              variant={darkMode.isDarkMode ? "outline" : "default"}
              className="dark:text-primary"
            >
              <XCircleIcon className="h-5 w-5 mr-1 -ml-1" aria-hidden="true" />
              Remove
            </Button>
          )}
        </div>
        {appliedPromoCode?.codeType == PromoCodeType.DISCOUNT && (
          <p className="text-xs mt-2 text-gray-700 dark:text-gray-400">
            {appliedPromoCode.name} applied. A &euro;
            {calculateDiscount(appliedPromoCode)} discount is available
            {appliedPromoCode.minimumCartValue && (
              <>
                {" "}
                on your cart when it is over &euro;
                {appliedPromoCode.minimumCartValue}
              </>
            )}
            .
          </p>
        )}
        {promoCodeError && (
          <div className="mt-4">
            <Error error={promoCodeError} />
          </div>
        )}
      </div>
    </Form>
  );
};

interface PromoCodeFormProps {}

// Wrap our form with the withFormik HoC
export const PromoCodeForm = withFormik<
  PromoCodeFormProps,
  PromoCodeFormValues
>({
  validationSchema: Yup.object({
    code: Yup.string().required("Required"),
  }),
  handleSubmit: (values) => {
    store.dispatch(
      cartActions.GetPromoCode({
        promoCode: values.code,
      })
    );
    // store.dispatch(cartActions.CreateOrder({ order: values }));
  },
})(PromoCodeInnerForm);
